import Box from '@mui/material/Box';
import {
  VideoMaxAdDurationTargeting,
  type VideoMaxAdDurationTargetingType,
} from '@openx/types/targeting/targetingValuesTypes';
import type { AdDurationOption, MaxAdDurationStatePayload } from '@openx/types/targeting/video';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BetweenItem } from '../components/BetweenItem';
import { ExactItem } from '../components/ExactItem';
import { getDurationOptionLabel } from '../utils/getDurationOptionLabel';

type Props = {
  type: VideoMaxAdDurationTargetingType | undefined;
  value: MaxAdDurationStatePayload | null;
  onChange: (newValue: Partial<MaxAdDurationStatePayload> | null) => void;
};

export const DurationSelection = ({ type, value, onChange }: Props) => {
  const { t } = useTranslation();
  const getOptionLabel = useCallback((option: AdDurationOption) => getDurationOptionLabel(option, t), [t]);

  const renderOption = useCallback(
    (props, option: string | null) => {
      const { key, ...rest } = props;

      return (
        <Box key={key} component="li" {...rest}>
          {getOptionLabel(option)}
        </Box>
      );
    },
    [getOptionLabel]
  );

  switch (type) {
    case VideoMaxAdDurationTargeting.EXACT:
      return <ExactItem renderOption={renderOption} onChange={onChange} value={value} />;
    default:
      return <BetweenItem renderOption={renderOption} onChange={onChange} value={value} />;
  }
};
